import React from 'react';
import styles from './styles.module.css';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { data, gradientStackData, sampleStackData } from './data';

const lineStyle={marginLeft:-20,fontSize:16,color:'gray'}
const modifiedBar=`<BarChart
width={340}
rotateLabel
barWidth={12}
spacing={40}
noOfSections={4}
barBorderRadius={6}
stackData={stackData}
/>`;
const StackedBar=props=>{
    const { isMobile } = props;
    return(
        <div className={styles.container} style={{ paddingLeft: isMobile ? 3 : 20 }}>
            <h2>
                Stacked Bar Charts
                <a style={{marginLeft:20,fontSize:15}} target="_blank" href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/blob/master/docs/BarChart/BarChartProps.md' rel="noreferrer">
                    props table
                </a>
            </h2>
            <div style={{marginLeft:10,marginBottom:100}}>
                <p>
                    Stacked bar chart has bars that have multiple sections stacked one above the other
                </p>
                <p>
                    To make stacked bar charts, we just send the prop <b>stackData</b> instead of data to the <b>{'<BarChart/>'}</b> component.
                </p>
                <h4>
                    Minimal Stacked Bar Chart
                </h4>
                <div style={{marginLeft:10}}>
                    <img
                        src={data[0].imgSrc}
                        className={styles.barOutput}
                        alt=''/>
                    <p>
                        The code for the above chart is-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[0].code}
                    </SyntaxHighlighter>
                </div>
                <h4>
                    Understanding the stackData
                </h4>
                <div style={{marginLeft:10}}>
                    <ul>
                        <li>
                            The stackData passed to the BarChart component is an array of objects.
                        </li>
                        <li>
                            Each object contains a mandatory key named <b>stacks</b>.
                        </li>
                        <li>
                            The value corresponding to the <b>stacks</b> key is an array of objects, each object representing a section of the stack.
                        </li>
                    </ul>
                    <img
                        src={require('../../../assets/stackdesc.png')}
                        className={styles.barOutput}
                        alt=''/>

                    <p>
                        The above stack chart can be styled a bit to create a beutiful stack chart like this-
                    </p>
                    <img
                        src={require('../../../assets/roundStackBar.png')}
                        className={styles.barOutput}
                        alt=''/>
                    <p>
                        For this, just reduce the barWidth and set <b>barBorderRadius</b> to half of the barWidth. Also adjust the <b>spacing</b>.<br/>
                        So the modified BarChart component will be like-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {modifiedBar}
                    </SyntaxHighlighter>
                    <p>
                        For this chart, the stackData is same as that for the previous chart.
                    </p>
                </div>
                <hr/>
                <br/>
                <h3>
                    Stacked Bar Chart with Gradient effect
                </h3>
                <div style={{marginLeft:10}}>
                    <p>
                        Below is a sample Stacked Bar chart.
                    </p>
                    <img
                        src={'https://user-images.githubusercontent.com/20596944/174616482-fe0b56a6-f8d7-44cd-b7e7-643658b379c5.png'}
                        className={styles.barOutput}
                        alt=''/>
                    <p>
                        The code for the above chart is-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {sampleStackData}
                    </SyntaxHighlighter>
                    <p>
                        Now, just add the prop <b>showGradient</b> to the <b>BarChart</b> component, and it results in-
                    </p>
                    <img
                        src={'https://user-images.githubusercontent.com/20596944/174617143-e944c478-68ec-4c2f-b961-92d80cd31db7.png'}
                        className={styles.barOutput}
                        alt=''/>
                    <p>
                        It takes <b>white</b> as the gradient color by default. We can change it using the <b>gradientColor</b> prop.<br/><br/>
                        The different bars can be given different values of gradientColor and color. Similarly, each section of a bar can be given different values of gradientColor and color. Here is an example-
                    </p>
                    <img
                        src={'https://user-images.githubusercontent.com/20596944/174619206-5fdd6ec1-815c-44a0-ad3a-71e1b6daaeec.png'}
                        className={styles.barOutput}
                        alt=''/>
                    <p>
                        The code for the above chart is-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {gradientStackData}
                    </SyntaxHighlighter>
                </div>
                <hr/>
                <br/>
            </div>
        </div>
    )
}

export default StackedBar;